<template>
  <JobCard :jobInfo="jobInfo2" showStatus>
    <div slot="header">
      <el-button type="primary" size="small" @click="optimizedResume"
        >优化简历</el-button
      >
    </div>
    <div slot="footer">{{ jobInfo2.reason }}</div>
  </JobCard>
</template>

<script>
import JobCard from "./JobCard.vue";
export default {
  props: {
    jobInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      jobInfo2: Object.assign({}, this.jobInfo, { stateDesc: "优化建议" })
    };
  },
  components: {
    JobCard
  },
  methods: {
    optimizedResume() {
      this.$router.push({ path: "/myresume" });
    }
  }
};
</script>

<style lang="scss"></style>
